import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { PetrusError } from "../../../config";
import { isFn } from "../../../services/utils";
import { config as refreshmentConfig } from "../modules/refreshment";
import { tokensPersistence } from "../modules/storage";
export const handlers = ({
  refreshTokens
} = {}) => {
  if (!isFn(refreshTokens)) {
    throw new PetrusError(`'refreshTokens' is not a function: Received argument: ${refreshTokens}.`);
  }

  return {
    refreshTokens
  };
};
export const options = (customOptions = {}) => _objectSpread(_objectSpread({
  applyAccessTokenExternally: false,
  autoStartTokensRetrieval: true
}, refreshmentConfig.options), customOptions);
export const initialState = (customInitialState = {}) => {
  return _objectSpread(_objectSpread({}, customInitialState), {}, {
    persistence: tokensPersistence.LOCAL
  });
};